








































import { Prop, Component, Vue } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import InvoiceSeachOptions from "@/ui/common/presenters/invoice-search-options";

@Component({})
export default class InvoiceSearchBar extends Vue {
  @Prop({ required: true }) options!: InvoiceSeachOptions;
  @Prop({ default: () => [] }) projectOptions!: SelectOption[];
  @Prop({ default: () => [] }) companyOptions!: SelectOption[];
  @Prop({ default: () => [] }) statusOptions!: SelectOption[];
  @Prop({ default: () => [] }) startDate!: SelectOption[];
  @Prop({ default: () => [] }) endDate!: SelectOption[];

  submit() {
    this.$emit("submit", this.options);
  }
}
